module.exports = __webpack_public_path__ + "img/icon-search.b0321dd2.svg";